import React, { useState } from "react";
import config from "../configs/config";
import { getLanguageSection } from "../shared/services/languageService";
import { buildReserveHotelUrl } from "../shared/services/reserveHotelService";
import Cookies from "js-cookie";
import ReservHotelContactModal from "../features/navigation/ui/ContactModal";

function ReservHotel() {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const language = getLanguageSection("reservhotel");
  const currentLanguage = Cookies.get("language");
  const isSpanish = currentLanguage === "esp";

  const quickLinks = [
    {
      title: language.quickLinks?.[0]?.title || "Media Kit",
      description: language.quickLinks?.[0]?.description || "Fotos, videos y FactSheets",
      href: isSpanish
        ? "https://marivalagents.com/es/multimedia"
        : "https://marivalagents.com/media-library",
      icon: "▣",
    },
    {
      title: language.quickLinks?.[1]?.title || "Bodas",
      description: language.quickLinks?.[1]?.description || "Paquetes y catálogos de bodas",
      href: isSpanish
        ? "https://marivalagents.com/es/bodas"
        : "https://marivalagents.com/weddings",
      icon: "∞",
    },
    {
      title: language.quickLinks?.[2]?.title || "Contacto",
      description: language.quickLinks?.[2]?.description || "",
      action: "contact",
      icon: "✉",
    },
  ];

  const mediaKitHref = isSpanish
    ? "https://marivalagents.com/es/multimedia"
    : "https://marivalagents.com/media-library";

  const resorts = [
    {
      title:
        language.resorts?.[0]?.title ||
        "Armony Marival Resort & Spa Punta de Mita - MGallery Collection",
      location: language.resorts?.[0]?.location || "Punta de Mita · Todo Incluido",
      image: `${config.publicurl}img/armony-resort.jpg?v=2`,
      logo: "https://www.marivalarmony.com/storage/logos/logo-armony-main-desktop.svg",
      href: mediaKitHref,
    },
    {
      title:
        language.resorts?.[1]?.title ||
        "Marival Distinct All-Suites & World Spa - Handwritten Collection",
      location: language.resorts?.[1]?.location || "Nuevo Vallarta · Todo Incluido",
      image: `${config.publicurl}img/marival-distinct.png?v=2`,
      logo: "https://www.marivaldistinct.com/storage/logos/distinct-logo-header-bco.svg",
      href: mediaKitHref,
    },
    {
      title:
        language.resorts?.[2]?.title ||
        "Marival Emotions Resort & Suites Riviera Nayarit by Mercure",
      location: language.resorts?.[2]?.location || "Nuevo Vallarta · Todo Incluido",
      image: `${config.publicurl}img/marival-emotions.jpg?v=2`,
      logo: "https://www.marivalemotions.com/storage/logo/logo-emotions-desktop.svg",
      href: mediaKitHref,
    },
  ];

  return (
    <div id="reservhotel" className="mr-ui bg-[#eef1f7] px-4 py-8 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-6xl">
        <div className="grid gap-6 lg:grid-cols-[minmax(0,1fr)_360px]">
          <section className="flex min-h-[286px] flex-col items-center justify-center rounded-2xl bg-[linear-gradient(135deg,#202865_0%,#202865_54%,#563162_100%)] px-8 py-9 text-center text-white shadow-sm sm:px-12">
            <p className="m-0 mb-4 text-[10px] font-bold uppercase tracking-[0.24em] text-white/60">
              {language.heroEyebrow}
            </p>
            <h1 className="m-0 max-w-4xl text-[30px] font-black leading-[1.08] sm:text-[34px]">
              {language.heroTitle}
            </h1>
            <p className="mx-auto mt-4 max-w-[640px] text-[13px] leading-5 text-white/80">
              {language.heroText}
            </p>
            <a
              href={buildReserveHotelUrl()}
              target="_blank"
              rel="noreferrer"
              className="mt-7 inline-flex min-h-[52px] items-center justify-center rounded-xl bg-[#ef5d70] px-8 text-sm font-black text-white shadow-[0_14px_28px_rgba(239,93,112,0.28)] transition hover:bg-[#e84f63] hover:text-white"
            >
              <span className="mr-2 text-base leading-none">▱</span>
              {language.heroButton}
              <span className="ml-3 text-lg leading-none">→</span>
            </a>
          </section>

          <aside className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
            <h2 className="m-0 mb-5 text-base font-black text-[#151b3f]">
              {language.quickLinksTitle}
            </h2>

            <div className="space-y-4">
              {quickLinks.map((link) => {
                const content = (
                  <>
                    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#202865] text-base font-black text-white">
                      {link.icon}
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="block text-sm font-black">{link.title}</span>
                      {link.description ? (
                        <span className="mt-1 block text-xs text-slate-500">
                          {link.description}
                        </span>
                      ) : null}
                    </span>
                    <span className="text-xl leading-none text-slate-500">›</span>
                  </>
                );

                if (link.action === "contact") {
                  return (
                    <button
                      key={link.title}
                      type="button"
                      className="flex w-full items-center gap-4 rounded-xl border border-slate-200 bg-white p-4 text-left text-[#151b3f] transition hover:border-[#4aa6cf] hover:text-[#151b3f] hover:shadow-sm"
                      onClick={() => setIsContactModalOpen(true)}
                    >
                      {content}
                    </button>
                  );
                }

                return (
                  <a
                    key={link.title}
                    href={link.href}
                    target="_blank"
                    rel="noreferrer"
                    className="flex items-center gap-4 rounded-xl border border-slate-200 bg-white p-4 text-[#151b3f] transition hover:border-[#4aa6cf] hover:text-[#151b3f] hover:shadow-sm"
                  >
                    {content}
                  </a>
                );
              })}
            </div>
          </aside>
        </div>

        <section className="mt-6 rounded-2xl border border-slate-200 bg-white p-6 shadow-sm lg:max-w-[760px]">
          <h2 className="m-0 mb-6 text-base font-black text-[#151b3f]">
            {language.resortsTitle}
          </h2>

          <div className="grid gap-5 sm:grid-cols-2">
            {resorts.map((resort) => (
              <a
                key={resort.title}
                href={resort.href}
                target="_blank"
                rel="noreferrer"
                className="group block overflow-hidden rounded-xl border border-slate-200 bg-white text-[#151b3f] transition hover:border-[#4aa6cf] hover:text-[#151b3f] hover:shadow-sm"
              >
                <div className="relative h-32 overflow-hidden bg-slate-100">
                  <img
                    src={resort.image}
                    alt=""
                    className="h-full w-full object-cover transition duration-300 group-hover:scale-[1.03]"
                  />

                  <div className="absolute inset-0 bg-black/40 transition group-hover:bg-black/50" />

                  <div className="absolute inset-0 flex items-center justify-center p-5">
                    <img
                      src={resort.logo}
                      alt={resort.title}
                      className="max-h-16 w-auto max-w-[78%] drop-shadow-[0_4px_14px_rgba(0,0,0,0.85)] transition duration-300 group-hover:scale-105"
                    />
                  </div>
                </div>

                <div className="p-4">
                  <h3 className="m-0 text-sm font-black leading-snug">{resort.title}</h3>
                  <p className="m-0 mt-1 text-xs text-slate-500">{resort.location}</p>
                </div>
              </a>
            ))}
          </div>
        </section>
      </div>

      <ReservHotelContactModal
        isOpen={isContactModalOpen}
        onClose={() => setIsContactModalOpen(false)}
        title={language.quickLinks?.[2]?.title || "Contact"}
      />
    </div>
  );
}

export default ReservHotel;